module.exports = __webpack_public_path__ + "img/orangeBg.55ca2ba4.png";